import React from 'react';

const CONVOS = [
  { name: 'Maria Silva', msg: 'Bom dia, preciso de uma limpeza', time: '09:42', unread: 2, avatar: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=120&h=120&fit=crop&crop=faces' },
  { name: 'João Pereira', msg: 'Confirmado para amanhã', time: '09:15', unread: 0, avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=120&h=120&fit=crop&crop=faces' },
  { name: 'Ana Costa', msg: 'O técnico já saiu?', time: '08:53', unread: 1, avatar: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=120&h=120&fit=crop&crop=faces' },
  { name: 'Pedro Santos', msg: 'Excelente serviço, obrigado!', time: 'Ontem', unread: 0, avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=120&h=120&fit=crop&crop=faces' },
  { name: 'Sofia Almeida', msg: 'Preciso reagendar para sexta', time: 'Ontem', unread: 0, avatar: 'https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?w=120&h=120&fit=crop&crop=faces' },
];

export const ScreenChatInbox = React.memo(() => (
  <div className="flex flex-col h-full bg-white">
    <div className="px-4 pt-3 pb-2 border-b border-gray-100">
      <div className="flex items-center justify-between">
        <div>
          <div className="text-[10px] uppercase tracking-widest text-gray-400 font-semibold">Inbox</div>
          <div className="text-[15px] font-semibold text-black">Conversas</div>
        </div>
        <div className="w-7 h-7 rounded-full bg-black flex items-center justify-center text-white text-[11px] font-semibold">3</div>
      </div>
    </div>
    <div className="flex-1 overflow-hidden">
      {CONVOS.map((c, i) => (
        <div key={i} className="flex items-center gap-2.5 px-4 py-2.5 border-b border-gray-50 hover:bg-gray-50">
          <img src={c.avatar} alt={c.name} className="w-8 h-8 rounded-full object-cover flex-shrink-0" loading="lazy" />
          <div className="flex-1 min-w-0">
            <div className="flex items-center justify-between">
              <div className="text-[11px] font-semibold text-black truncate">{c.name}</div>
              <div className="text-[9px] text-gray-400 flex-shrink-0 ml-1">{c.time}</div>
            </div>
            <div className="flex items-center justify-between mt-0.5">
              <div className="text-[10px] text-gray-500 truncate">{c.msg}</div>
              {c.unread > 0 && (
                <div className="ml-1 min-w-[16px] h-4 px-1 rounded-full bg-black text-white text-[9px] font-semibold flex items-center justify-center flex-shrink-0">{c.unread}</div>
              )}
            </div>
          </div>
        </div>
      ))}
    </div>
  </div>
));
ScreenChatInbox.displayName = 'ScreenChatInbox';
